import { createContext, useContext } from 'react'

export const ClientPersonsTableContext = createContext({
  editing: false
})

export const useClientPersonsActions = () => {
  return useContext(ClientPersonsTableContext)
}
